import React, { useEffect, useState } from "react";
import { Feather } from "lucide-react";
import api from "@/lib/api";

/** Original editorial introduction for a date (AI-written once, template fallback) - the "substantial unique value" on every date page. */
export const DateIntro = ({ ddmm, intro: given, className = "" }) => {
  const [intro, setIntro] = useState(given || null);
  useEffect(() => {
    if (given) { setIntro(given); return; }
    if (!ddmm) return;
    let live = true;
    api.get(`/seo/intro/${ddmm}`).then((r) => { if (live) setIntro(r.data.intro); }).catch(() => {});
    return () => { live = false; };
  }, [ddmm, given]);
  if (!intro) return null;
  const paras = intro.split(/\n\s*\n/);
  return (
    <div data-testid="date-intro" className={`relative pl-5 border-l-2 border-gold ${className}`}>
      <Feather className="absolute -left-[11px] top-0 w-5 h-5 p-0.5 bg-paper-light text-gold" />
      {paras.map((p, i) => (
        <p key={i} className={`font-vintage text-[15px] sm:text-[16px] leading-[1.75] text-[#333] ${i || /^\d/.test(p) ? "" : "first-letter:text-[2.1em] first-letter:font-bold first-letter:float-left first-letter:mr-2 first-letter:leading-[0.9] first-letter:text-ink"} ${i ? "mt-3" : ""}`}>{p}</p>
      ))}
    </div>
  );
};
